import React, { useState } from 'react';
import GenericButton from './GenericButton';
import OnboardUsersModal from '../../../modal/OnboardUsersModal';

interface IOnboardUserButtonProps {
  title: string;
}

/**
 * OnboardUserButton component
 *
 * @param {*} { title }
 * @return {*}
 */
const OnboardUserButton: React.FC<IOnboardUserButtonProps> = ({ title }) => {
  const [onboardUserModalOpen, setOnboardUserModalOpen] = useState(false);

  const showOnboardUserModal = () => {
    setOnboardUserModalOpen(true);
  };

  const onClose = () => {
    setOnboardUserModalOpen(false);
  };

  return (
    <>
      <OnboardUsersModal isVisible={onboardUserModalOpen} onClose={onClose} />
      <GenericButton
        title={title}
        onPress={showOnboardUserModal}
        isPrimary={true}
        buttonStyle={{ width: 127, height: 41, borderRadius: 6, backgroundColor: '#1C274C' }}
        textStyle={{ fontSize: 14, fontWeight: 700 }}
      />
    </>
  );
};

export default OnboardUserButton;
